import React from 'react';
import { Container } from '../../components/Container/Container';
import { Card } from '../../components/Card/Card';
import './ErrorBoundary.css';
import { withRouter, RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { publicPath } from '../../model/config';
import { t } from '../../locales/translate';
import { Modal } from '../../components/Modal/Modal';
import { Button } from '../../components/Button/Button';

interface Props {
  location: {
    pathname: string;
  };
  inline?: boolean;
  withModal?: boolean;
}

export class ErrorBoundary extends React.Component<RouteComponentProps<Record<string, string>> & Props> {
  public state = {
    hasError: false,
    error: undefined,
  };

  public componentDidCatch(e: Error): void {
    // Display fallback UI
    this.setState({
      hasError: true,
      error: e,
    });
  }

  public componentDidUpdate(prevProps: Props): void {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({
        hasError: false,
        error: { name: '', message: '' },
        componentStack: '',
      });
    }
  }

  public render(): React.ReactNode {
    const content = (
      <section className="error-boundary__message">
        <p>{t.errors.errorLoadingPage}</p>
      </section>
    );
    if (this.state.hasError) {
      if (this.props.inline) {
        return content;
      }

      if (this.props.withModal) {
        return (
          <Modal
            open
            footer={
              <Button
                title={t.actions.reload}
                type="primary"
                onClick={() => {
                  window.location.reload();
                }}
              />
            }
          >
            {content}
          </Modal>
        );
      }

      return (
        <Container className="error-boundary">
          <Card
            size="large"
            className="error-boundary__card"
            title={t.general.error}
            footer={
              <Link className="button button--primary" to={publicPath}>
                {t.general.backHome}
              </Link>
            }
          >
            {content}
          </Card>
        </Container>
      );
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
